module.exports = __webpack_public_path__ + "static/media/20.068cb4c3.jpg";